import React from 'react';

import { Button } from 'reactstrap';

import { Switch } from 'triider-components';
import backButton from 'assets/img/backButton.svg';
import {
  ModalStyled, Header, Body, Footer, BackButton,
} from './styles';

const Modal = ({
  isOpen,
  toggle,
  title,
  children,
  footerClick,
  footer,
  width,
  height,
  top,
  disabled,
  padding,
  overflow,
  borderbottomheader,
  paddingheader,
  textalingheader,
  backgroundcolor,
  backgroundclip,
  disabledCloseButton,
  modallist,
  fontSizeHeader,
  boldHeader,
  textTransform,
  haveSwitch,
  valueSwitch,
  onChangeSwitch,
  haveGoBack,
  goBack,
  noSpaceBetween,
}) => (
  // Não usado camelCase, pois o React informa warning:React does not recognize the prop X
  <ModalStyled
    isOpen={isOpen}
    toggle={toggle}
    width={width}
    height={height}
    top={top}
    backgroundcolor={backgroundcolor}
    backgroundclip={backgroundclip}
    disabled_close_button={disabledCloseButton}
  >
    <Header
      texttransform={textTransform}
      font_size_header={fontSizeHeader}
      bold_header={boldHeader}
      modallist={modallist}
      toggle={toggle}
      paddingheader={paddingheader}
      borderbottomheader={borderbottomheader}
      textalingheader={textalingheader}
      no_space_between={noSpaceBetween}
    >
      {haveGoBack
        && <BackButton onClick={goBack} src={backButton} />
      }
      {title}
      {haveSwitch
        && (
        <Switch
          value={valueSwitch}
          checked={valueSwitch}
          onChange={onChangeSwitch}
        />
        )
      }
    </Header>
    <Body padding={padding} overflow={overflow}>
      {children}
    </Body>
    {footer && footerClick && (
      <Footer disabled={disabled}>
        <Button disabled={disabled} onClick={() => footerClick()}>
          {footer}
        </Button>
      </Footer>
    )}
  </ModalStyled>
);

export default Modal;
